import * as React from 'react';

import { EnterpriseLearningPathPageDirector } from 'bundles/enterprise-learning-path-description-page/pages/EnterpriseLearningPathPageDirector';
import EnterpriseOrgScopedLearningPathDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseOrgScopedLearningPathDataProvider';
import DisableCrawlerIndexing from 'bundles/seo/components/DisableCrawlerIndexing';

const EnterpriseOrgScopedLearningPathPageDirector = () => {
  return (
    <EnterpriseOrgScopedLearningPathDataProvider>
      <DisableCrawlerIndexing />
      <EnterpriseLearningPathPageDirector />
    </EnterpriseOrgScopedLearningPathDataProvider>
  );
};

export default EnterpriseOrgScopedLearningPathPageDirector;
